import React from "react";
import styled from "styled-components";
import { Colors, Text, Metrics } from "@origin-digital/style-guide";
import { getCloudinaryUrl } from "../NextBestAction.utils";
export var Heading = styled(Text).withConfig({
  displayName: "Header__Heading",
  componentId: "sc-1ic7ieo-0"
})(["font-weight:", ";font-size:", "px;color:", ";width:", ";"], Metrics.FontWeights.MEDIUM, Metrics.FontSizes.H4, Colors.GREY56, function (props) {
  return props.isDismissable ? "calc(100% - 32px)" : "100%";
});
var HeadingSection = styled.div.withConfig({
  displayName: "Header__HeadingSection",
  componentId: "sc-1ic7ieo-1"
})(["align-items:center;display:flex;justify-content:flex-start;"]);
var PaddedIcon = styled.img.withConfig({
  displayName: "Header__PaddedIcon",
  componentId: "sc-1ic7ieo-2"
})(["padding-right:10px;"]);
export var Header = function Header(_ref) {
  var content = _ref.content;
  return React.createElement(HeadingSection, null, content.headingIconSha && React.createElement(PaddedIcon, {
    src: getCloudinaryUrl(content.headingIconSha, 25, 25)
  }), React.createElement(Heading, {
    isDismissable: content.isDismissable
  }, content.heading));
};